import React from 'react';

var Favourites = function Favourites(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.04l-1.992-2.002a3.502 3.502 0 0 0-4.975-.003 3.579 3.579 0 0 0 .003 5.034l6.842 6.88a.17.17 0 0 0 .243 0l6.842-6.88a3.576 3.576 0 0 0 .003-5.034 3.505 3.505 0 0 0-4.975.003l-1.992 2.003zm0-2.836l.759-.755a5.505 5.505 0 0 1 7.625.176 5.576 5.576 0 0 1-.003 7.855l-6.842 6.88a2.17 2.17 0 0 1-3.08 0l-6.841-6.88a5.579 5.579 0 0 1-.003-7.855 5.502 5.502 0 0 1 7.625-.176l.76.755z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Favourites.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Favourites as icon };
export default iconHandler(Favourites);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Favourites.js
// module id = 598
// module chunks = 0